<template>
  <div
    :class="height"
    v-show="active_stream"
    class="glass-carbon border-ontick-steel-400 absolute bottom-0 z-20 max-h-screen w-full overflow-y-auto border-t transition-all duration-500 ease-in-out"
  >
    <div class="relative px-6 pb-20">
      <div
        class="dark:bg-ontick-carbon-500 sticky top-0 z-10 bg-gray-50 bg-opacity-90 py-3 backdrop-blur-sm backdrop-opacity-90 backdrop-filter"
      >
        <div class="flex items-center">
          <div class="inline-flex flex-1 space-x-6">
            <div class="w-32">
              <span v-html="$icons.stream"></span>
            </div>
            <div class="inline-flex space-x-3 text-sm">
              <button
                @click="(tab.real = true), (tab.history = false)"
                class="border-b"
                :class="
                  tab.real
                    ? 'border-ontick-blue-500 text-ontick-steel-900 dark:text-gray-300'
                    : 'text-ontick-steel-800 dark:border-ontick-steel-800 border-gray-50 dark:text-gray-500'
                "
              >
                Tempo Real
              </button>
              <button
                @click="(tab.real = false), (tab.history = true)"
                class="border-b"
                :class="
                  tab.history
                    ? 'border-ontick-blue-500 text-ontick-steel-900 dark:text-gray-300'
                    : 'text-ontick-steel-500 dark:border-ontick-carbon-500 border-gray-50 dark:text-gray-500'
                "
              >
                Histórico
              </button>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <button @click="height == 'h-3/6' ? (height = 'h-full') : (height = 'h-3/6')">
              <svg
                class="text-ontick-carbon-900 h-8 w-8 transform dark:text-gray-300"
                :class="height == 'h-3/6' ? 'rotate-180' : 'rotate-0'"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
                <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
              </svg>
            </button>
            <button @click="$emit('close')">
              <span class="text-ontick-carbon-900 dark:text-gray-300" v-html="$icons.close"></span>
            </button>
          </div>
        </div>
      </div>

      <div v-if="tab.real" class="space-y-6">
        <div v-if="loading" class="flex w-full items-center justify-center py-16">
          <i v-html="$icons.loading"></i>
        </div>
        <div v-else-if="!positions.length">
          <h2 class="text-ontick-carbon-900 py-16 text-center text-2xl font-medium dark:text-gray-300">
            Nenhuma posição aberta.
          </h2>
        </div>

        <new-position-table-component v-else :positions="positions" :connectionStatus="connectionStatus" />
        <template v-if="!loading">
          <div v-if="!orders.length">
            <h2 class="text-ontick-carbon-900 py-16 text-center text-2xl font-medium dark:text-gray-300">
              Nenhuma ordem pendente.
            </h2>
          </div>
          <new-order-table-component :orders="orders" v-else />
        </template>
      </div>

      <table-history v-else-if="tab.history" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import TableOrder from "../components/table.order.component.vue";
import TablePosition from "../components/table.position.component.vue";
import TableHistory from "../components/table.history.component.vue";
import { v4 as uuidv4 } from "uuid";
import EventBus from "../../../shared/utils/event_bus";
import NewPositionTableComponent from "../components/position-table/new-position-table.component.vue";
import NewOrderTableComponent from "../components/order-table/new-order-table.component.vue";

export default {
  components: {
    TableOrder,
    TablePosition,
    TableHistory,
    NewPositionTableComponent,
    NewOrderTableComponent,
  },

  props: {
    active_stream: Boolean,
  },

  data() {
    return {
      height: "h-3/6",
      index_buttons: 0,
      positions: [],
      orders: [],
      window_component: true,
      tab: { real: true, history: false },

      // placeholder: true,
      contextUuid: uuidv4(),
      connectionStatus: {
        awaitingConnection: false,
        retries: 0,
        error: false,
      },
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      getWebsocketIsConnected: "config/getWebsocketIsConnected",
      selectedAccount: "accountTypes/getSelectedAccount",
      marketdata: "marketdata/getMarketdata",
    }),
    topics() {
      let topics = [];
      this.positions.forEach((pos) => {
        if (["PORTFOLIO", "MULTISYMBOL"].includes(pos.type)) {
          pos.curr_positions.forEach((curr) => {
            topics.push(curr.position_symbol);
          });
        } else {
          topics.push(pos.position_symbol);
        }
      });
      return Array(...new Set(topics)).map((symbol) => this.formatTopic(symbol));
    },
  },

  methods: {
    formatSymbol(topic) {
      return topic.split(".")[1];
    },
    formatTopic(symbol) {
      return `MD.${symbol}.L1`;
    },
    consume() {
      if (this.connectionStatus.retries > 5) {
        this.connectionStatus.error = true;
        console.error("[STREAMER] Erro ao conectar ao websocket.");
        return;
      }
      if (!this.getWebsocketIsConnected) {
        if (this.isSharedWorker) this.worker.sendMessage({ type: "CHECK_CONNECTION" });
        this.connectionStatus.retries++;
        this.connectionStatus.awaitingConnection = true;
        setTimeout(() => {
          this.consume();
        }, 2000);
        return;
      }
      this.connectionStatus.awaitingConnection = false;
      this.connectionStatus.error = false;
      this.worker.sendMessage({
        type: "CONSUME",
        data: {
          uuid: this.contextUuid,
          topics: this.topics,
          type: "Streamer",
        },
      });
    },
    stopConsuming() {
      this.worker.sendMessage({
        type: "STOP_CONSUMING",
        data: this.contextUuid,
      });
    },
    updatePosition(payload) {
      if (this.selectedAccount.account_id == payload.account_id) {
        if (!payload.portfolio_id) {
          let index = this.positions.findIndex((x) => Number(x.investment_id) == payload.investment_id);

          if (index != -1) {
            if (payload.event == "NEW_POSITION" || payload.event == "UPDATE_POSITION") {
              //ATUALIZAR POSIÇÃO
              // console.log(
              //   `Position: ${this.positions[index].strategy_name}; Old volume: ${this.positions[index].position_volume}; New volume: ${payload.position_volume_current}`
              // );
              this.positions[index].position_volume = Number(payload.position_volume_current);
              // this.positions[index].position_type = payload.position_type;
              this.positions[index].position_price = Number(payload.position_price_avg);
              this.positions[index].position_time = payload.position_time;
              this.positions[index].position_tp = payload.position_tp;
              this.positions[index].position_sl = payload.position_sl;
            } else {
              //REMOVER POSIÇÃO
              this.positions.splice(index, 1);
            }
          } else {
            //NOVA POSIÇÃO
            this.positions.push(this.newPosition(payload));
          }
        }
      }
    },

    updateOrder(payload) {
      // console.log("update order", payload);
      if (this.selectedAccount.account_id == payload.account_id) {
        if (!payload.portfolio_id) {
          let index = this.orders.findIndex(
            (x) => Number(x.investment_id) == payload.investment_id && x.order_id == payload.order_id
          );

          if (index != -1) {
            if (payload.event == "NEW_ORDER" || payload.event == "UPDATE_ORDER") {
              //ATUALIZAR ORDEM
              this.orders[index].order_volume = Number(payload.order_volume);
              this.orders[index].order_type = payload.order_type;
              this.orders[index].order_price = Number(payload.order_price);
              this.orders[index].order_time = payload.order_time;
              this.orders[index].order_comment = payload.order_comment;
              this.orders[index].order_state = payload.order_state;
            } else if (payload.event == "ORDER_CLOSE") {
              //REMOVER ORDEM
              this.orders.splice(index, 1);
            }
          } else {
            //NOVA ORDEM
            if (payload.event != "ORDER_CLOSE") {
              this.orders.push(this.newOrder(payload));
            }
          }
        }
      }
    },

    newOrder(payload) {
      let new_order = {
        strategy_name: payload.strategy_name,
        order_id: payload.order_id,
        order_state: payload.order_state,
        order_goal: payload.order_goal,
        order_volume: Number(payload.order_volume),
        order_type: payload.order_type,
        order_price: Number(payload.order_price),
        order_direction: payload.order_direction,
        order_time: payload.order_time,
        investment_id: payload.investment_id,
        order_symbol: payload.order_symbol,
        order_comment: payload.order_comment,
      };

      return new_order;
    },

    newPosition(payload) {
      let new_position = {
        strategy_name: payload.strategy_name,
        position_id: payload.position_id,
        position_sl: payload.position_sl,
        position_tp: payload.position_tp,
        position_volume: Number(payload.position_volume_current),
        position_type: payload.position_type,
        position_price: Number(payload.position_price_avg),
        position_price_avg: payload.position_price_avg,
        position_profit: payload.position_profit,
        position_time: payload.position_time,
        position_comment: payload.position_comment,
        investment_id: payload.investment_id,
        position_symbol: payload.position_symbol,
        open_pnl: null,
        chart: null,
      };

      return new_position;
    },

    start(symbol) {
      if (!this.topics.includes(`MD.${symbol.toUpperCase()}.L1`)) {
        this.topics.push(`MD.${symbol.toUpperCase()}.L1`);
      }
    },

    updateOpenPnl(obj, symbol, last_price) {
      let open_pnl;
      if (obj.position_symbol == symbol) {
        let symbol_details = this.$getTickProfit(symbol);
        if (["Comprado", "BUY"].includes(obj.position_status)) {
          open_pnl =
            ((last_price - obj.position_price) / symbol_details.tick_size) *
            symbol_details.tick_profit *
            obj.position_volume;
          this.$set(obj, "open_pnl", open_pnl);
        } else if (["Vendido", "SELL"].includes(obj.position_status)) {
          open_pnl =
            ((obj.position_price - last_price) / symbol_details.tick_size) *
            symbol_details.tick_profit *
            obj.position_volume;
          this.$set(obj, "open_pnl", open_pnl);
        }
      }

      return obj;
    },

    updateMarketdata(symbol, last_price) {
      if (last_price) {
        this.positions.forEach((position) => {
          if (["PORTFOLIO", "MULTISYMBOL"].includes(position.type)) {
            position.curr_positions.forEach((sub_position) => {
              sub_position = this.updateOpenPnl(sub_position, symbol, last_price);
            });
          } else {
            position = this.updateOpenPnl(position, symbol, last_price);
          }
        });
      }
    },

    getRealTime(account) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.$api
          .get(`${this.$endpoint.REAL_TIME}/${account}`)
          .then((res) => {
            resolve({
              orders: res.data.orders,
              positions: res.data.positions,
            });
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },

  watch: {
    height: {
      deep: true,
      handler(value) {
        localStorage.setItem("height", value);
        return value;
      },
    },

    position: {
      deep: true,
      handler(value) {
        this.updatePosition(value.data[0], value.datetime);
        return value;
      },
    },

    order: {
      deep: true,
      handler(value) {
        this.updateOrder(value.data[0], value.datetime);
        return value;
      },
    },

    selectedAccount: {
      deep: true,
      handler(value) {
        if (value.account_id) {
          this.getRealTime(value.account_id)
            .then(({ orders, positions }) => {
              this.orders = orders;
              this.positions = positions;
            })
            .catch((err) => {
              console.error(err);
            });
        }
      },
    },

    topics: {
      handler(val) {
        if (val) {
          this.consume();
        }
      },
    },

    marketdata: {
      deep: true,
      handler(val) {
        // console.log("%c------------", "color:#f72585;");
        // console.log("%c@[STREAMER]", "padding:3px;font-weight:bold;background-color:#f72585;color:white;", val);
        // console.log("this.topics....", this.topics);
        if (this.topics) {
          this.topics.forEach((topic) => {
            const symbol = this.formatSymbol(topic);
            this.updateMarketdata(symbol, val[symbol]);
          });
        }
        return val;
      },
    },
  },

  mounted() {
    this.height = localStorage.getItem("height");
    const getData = (account_id) => {
      if (account_id) {
        this.getRealTime(account_id)
          .then(({ orders, positions }) => {
            let updateOpenPnl = (position_status, position_price, position_volume, position_symbol, last_price) => {
              let open_pnl = 0;
              let symbol_details = this.$getTickProfit(position_symbol);
              if (["Comprado", "BUY"].includes(position_status)) {
                open_pnl =
                  ((last_price - position_price) / symbol_details.tick_size) *
                  symbol_details.tick_profit *
                  position_volume;

                return open_pnl;
              } else if (["Vendido", "SELL"].includes(position_status)) {
                open_pnl =
                  ((position_price - last_price) / symbol_details.tick_size) *
                  symbol_details.tick_profit *
                  position_volume;
                return open_pnl;
              }

              return 0;
            };

            this.orders = orders;

            this.positions = positions.map((item) => {
              if (["PORTFOLIO", "MULTISYMBOL"].includes(item.type)) {
                item.curr_positions = item.curr_positions.map((position) => {
                  let new_position = position;

                  new_position.open_pnl = updateOpenPnl(
                    position.position_status,
                    position.position_price,
                    position.position_volume,
                    position.position_symbol,
                    Number(position.symbol_last_price)
                  );

                  return new_position;
                });
                let new_item = {
                  ...item,
                  open_pnl: item.curr_positions.reduce((acc, curr) => acc + curr.open_pnl, 0),
                };

                return new_item;
              } else {
                let new_item = {
                  ...item,
                  open_pnl: updateOpenPnl(
                    item.position_status,
                    item.position_price,
                    item.position_volume,
                    item.position_symbol,
                    Number(item.symbol_last_price)
                  ),
                };

                return new_item;
              }
            });
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        setTimeout(() => {
          getData(account_id);
        }, 1000);
      }
    };
    getData(this.selectedAccount.account_id);
  },

  beforeDestroy() {
    this.stopConsuming();
  },
};
</script>
